var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStepcontact = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 17,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M8 12.883a3.98 3.98 0 0 1-3.183-1.6A3.98 3.98 0 0 1 8 9.683c1.304 0 2.45.634 3.182 1.6A3.98 3.98 0 0 1 8 12.883m0-8a1.601 1.601 0 0 1 0 3.2 1.601 1.601 0 0 1 0-3.2m0-2.4a6.407 6.407 0 0 0-6.4 6.4c0 3.53 2.87 6.4 6.4 6.4 3.528 0 6.4-2.87 6.4-6.4 0-3.528-2.872-6.4-6.4-6.4",
  clipRule: "evenodd",
  opacity: 0.8
})));
export { SvgStepcontact as ReactComponent };
export default __webpack_public_path__ + "static/media/step.contact.b215e540.svg";